import { Component, Input, OnInit } from '@angular/core';

export enum tipoAvatar {
  simple = 'simple',
  completo = 'completo'
}

@Component({
  selector: 'app-avatar-usuario',
  templateUrl: './avatar-usuario.component.html',
  styleUrls: ['./avatar-usuario.component.scss']
})
export class AvatarUsuarioComponent implements OnInit {
  @Input() imagen: string;
  @Input() url: string = '';
  @Input() nombre: string = '';
  @Input() clase: string = ''; 
  @Input() tipo: tipoAvatar = tipoAvatar.completo; 

  imagenEncontrada: boolean = true;

  constructor() { }

  ngOnInit(): void {
    if (!this.tipo) this.tipo = tipoAvatar.completo;
    if (this.imagen) {
      this.comprobarImagen(this.imagen);
    }
  }

  getInicialesNombre(nombre: string): string {
    if(nombre) return nombre.slice(0, 1);
  }

  comprobarImagen(imagen: string) {
    let img = new Image();
    img.src = imagen;

    img.onload = () => {
      this.imagenEncontrada = true;
    };

    img.onerror = () => {
      this.imagenEncontrada = false;
    };
  }

}